import React, { SFC, JSX } from "react";
import withTheme, { PropsType as WithThemeProps } from "../../hoc/withTheme";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import "./style.scss";

type PartnerType = {
    id: string;
    name: string;
    text: string;
    src: string;
    srcSet: string;
}
type PropsType = HTMLProps<HTMLDivElement> &
    WithVerticalSpacingProps &
    WithContentWrapProps &
    WithThemeProps & {
        title: string;
        partners: Array<PartnerType>;
    };

const MainPartners: SFC<PropsType> = (props: PropsType): JSX.Element => {
    const theme = props.theme.text ? props.theme.text : "inherit";

    return (
        <div
            id={props.id}
            className="MainPartners"
            style={{ color: theme }}
        >
            <div className="MainPartners__wrap">
                {props.partners.map(partner => {
                    return (
                        <div id={`partner-${partner.id}`} className="MainPartners__partner">
                            <div className="MainPartners__partner-image">
                                <img src={partner.src} srcSet={partner.srcSet} />
                            </div>
                            <div className="MainPartners__partner-content">
                                <h2>{partner.title}</h2>
                                <p>{partner.text}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default withTheme(withVerticalSpacing(withContentWrap(MainPartners)));
